<template>
  <div class="d-flex" :class="{'flex-wrap': pill, 'flex-nowrap': !pill }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TabNav",
  props: {
    id: {
      type: String,
      required: true,
    },
    pill: {
      type: Boolean,
    }
  },
};
</script>
